import { render, staticRenderFns } from "./VueStars.vue?vue&type=template&id=2eb9e134"
import script from "./VueStars.vue?vue&type=script&lang=js"
export * from "./VueStars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports